<div class="news-card">
  <div class="card-img-content" *ngIf="urlImg">
    <img src="{{urlImg}}" alt="" height="118.6px" width="100%">
  </div>
  <div class="card-img-content" [ngStyle]="{ 'background-image': 'url(' + urlImg + ')'}" *ngIf="urlImg"></div>
  <div class="card-title-content" [ngClass]="{'ft': data.agencyCode === agencyNewsEnum.INVESTIMMENTOS_NOTICIA,
    'cedro': data.agencyCode === agencyNewsEnum.CEDRO, 'bovespa': data.agencyCode === agencyNewsEnum.BOVESPA,
    'bmf': data.agencyCode === agencyNewsEnum.BMF}">
    <div class="title-header">
      <div class="row m-0">
        <div class="col-5 p-0 news-agency"><img class="img-compamy" src="{{companyImg}}">{{new.agencyDescription}}</div>
        <div class="col-7 news-date">{{new.newsDate | date: 'dd \'DE\' MMMM yyyy - HH:mm:ss'| uppercase}}</div>
        <div class="col-12 col-hr">
          <hr>
        </div>
        <div (click)="openDetails()" class="col-12 col-title">{{ cutString(new.title, 39) }} <br>
        </div>
      </div>
    </div>
  </div>
  <div class="card-content">
    <div class="row">
      <div class="col-12 col-content">{{ cutString(description, 141 ) }}</div>
    </div>
    <div class="gradient-content">
    </div>
    <div class="div-detail">
      <button (click)="openDetails()" class="btn-details">SAIBA MAIS</button>
    </div>
  </div>
</div>
